import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  LOGIN_PASSWORDLESS,
  LOGOUT_USER,
} from './constant';

export const loginUser = (username, password) => ({
  type: LOGIN_USER,
  username,
  password
});
export const loginPasswordless = (passwordlessToken) => ({
  type: LOGIN_PASSWORDLESS,
  passwordlessToken,
});
export const loginUserSuccess = (user) => ({
  type: LOGIN_USER_SUCCESS,
  payload: user,
});
export const loginUserError = (payload) => ({
  type: LOGIN_USER_ERROR,
  payload,
});

export const logoutUser = () => ({
  type: LOGOUT_USER,
});
